import { gql } from '@apollo/client';

export type { GenerateApiKey as IGenerateApiKey } from './__generated__/GenerateApiKey';

export const GENERATE_API_KEY = gql`
  mutation GenerateApiKey {
    createPartnerAuthToken
  }
`;
